module.exports = __webpack_public_path__ + "static/media/icon_change_modal.33382e59.svg";